import { useEffect, useState } from "react";
import RxPaper from "../../components/RxPaper";
import api from "../../config/AxiosConfig";
import { AcademicInfoDTO } from "../../constants/CommonObject";
import styles from "./AcademicLicence.module.css";
import AcademicLicenceForm from "./AcademicLicenceForm/AcademicLicenceForm";
import AuthUserAcademicLicencePage from "./AuthUserAcademicLicencePage/AuthUserAcademicLicencePage";

const AcademicLicence = () => {
	const [academicInfo, setAcademicInfo] = useState<AcademicInfoDTO>();

	const getAuthUserAcademicLicence = async () => {
		const academicLicence = await api.get<AcademicInfoDTO>(
			`/1/academic-infos`
		);
		setAcademicInfo(academicLicence);
	};

	useEffect(() => {
		void getAuthUserAcademicLicence();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleView = () => {
		if (academicInfo && academicInfo.id !== null) {
			return <AuthUserAcademicLicencePage academicInfo={academicInfo} />;
		} else if (academicInfo && academicInfo.id === null) {
			return <AcademicLicenceForm setAcademicInfo={setAcademicInfo} />;
		} else {
			return <></>;
		}
	};

	return <RxPaper className={styles.mainPaper}>{handleView()}</RxPaper>;
};

export default AcademicLicence;
